import { HeaderMetadataStatus, Text } from '@backstage/ui';
import type { Codespace } from '../../types';

export const CodespaceStatus = ({ codespace }: { codespace: Codespace }) => {
  if (codespace.autoDeleteWarningLabel) {
    return <HeaderMetadataStatus label={codespace.autoDeleteWarningLabel} color="warning" />;
  }

  if (codespace.isRunning) {
    return <HeaderMetadataStatus label={codespace.stateLabel} color="success" />;
  }

  return (
    <Text variant="body-medium" as="span">
      {codespace.stateLabel}
    </Text>
  );
};
